import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function lockWorkbook(id: number, lock = true): Promise<void> {
    if (api.clientApi) {
        await api.clientApi.clientWorkbookPartialUpdate(store.db ? store.db : "", id, { is_locked: lock }).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
        });
    }
}

async function tempLockWorkbook(id: string, force = false): Promise<boolean> {
    if (!api.clientApi) {
        return false;
    }

    await api.clientApi.clientWorkbookTableLock(store.db ? store.db : "", id, force).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }

            return false;
        }
    });

    return true;
}

export { lockWorkbook, tempLockWorkbook };
